import React from 'react';
import PropTypes from 'prop-types';

const Misc = ({ systemNotes }) => (
    <div>
        <div className="col">
            <p className="specsText">{systemNotes}</p>
        </div>
    </div>
);

Misc.propTypes = {
    systemNotes: PropTypes.string.isRequired,
};

export default Misc;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/MISC/MISC.js